import {
  NodeOperationsConfirmationButton,
  OpButtonProps,
} from '../../contentService/NodeOperationsConfirmationButton'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { flowIdsAtom } from './atoms'
import * as React from 'react'

export function NodeOperationsButton(
  params: Omit<OpButtonProps, 'onFlowCreated'>,
) {
  const setter = useSetAtom(flowIdsAtom)
  const onFlowCreated = (flowId: string) => {
    setter((prev) => [flowId, ...prev])
  }
  return (
    <NodeOperationsConfirmationButton
      {...params}
      onFlowCreated={onFlowCreated}
    />
  )
}
